import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";
import "./fonts/ArgentumSans-Medium.ttf";
import "react-calendar/dist/Calendar.css";
import TagManager from "react-gtm-module";

const tagManagerArgs = {
  gtmId: "GTM-NMP4P5N",
};

TagManager.initialize(tagManagerArgs);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
